import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Register from './Pages/Register';
import Login from './Pages/Login';
import ForgetPass from './Pages/ForgetPass';
import ProtectedRoute from './Pages/ProtectedRoute';  // Import the ProtectedRoute component
import Dashboard from './Pages/Dashboard';  // Only include the Dashboard route here
import Admin from './Admincomp/Admin';  // Import the Admin component
import Dashadmin from './Admincomp/Dashadmin';  // Import the Dashadmin component

function App() {
  return (
    <Router>
      <div className="App" style={{ backgroundColor: 'lightblue', padding: '20px' }}>
        <Routes>
          {/* Protected route for the dashboard */}
          <Route 
            path="/dashboard/*" 
            element={
              <ProtectedRoute roleRequired="user">
              <Dashboard />
            </ProtectedRoute>
            }
          />
 {/* Protected route for the admin dashboard */}
 <Route 
            path="/dashadmin/*" 
            element={
              <ProtectedRoute roleRequired="admin">
                <Dashadmin />
              </ProtectedRoute>
            }
          />

          {/* Admin route (public for admin login) */}
          <Route path="/admin" element={<Admin />} />
          
          {/* Public routes */}
          <Route path="/forgetPass" element={<ForgetPass />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<Login />} />
        </Routes>

      </div>
    </Router>
  );
}

export default App;
